import { FilledNewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const HomeIcon = ({ fill, color, className }: FilledNewIconProps) =>
  fill ? (
    <svg
      className={twMerge('size-[26px]', className)}
      width="100%"
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4 23V9.66667L13 3L22 9.66667V23H14.125V16.3333H11.875V23H4Z" fill={color} />
    </svg>
  ) : (
    <svg
      className={twMerge('size-[26px]', className)}
      width="100%"
      height="100%"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.875 14.3333H16.125V21H20V10.6741L13 5.48893L6 10.6741V21H9.875V14.3333ZM11.875 23H4V9.66667L13 3L22 9.66667V23H14.125V16.3333H11.875V23Z"
        fill={color}
      />
    </svg>
  );
